import React from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import Icon from "../../components/AppIcon"
import { FloatingPaths } from "../../components/ui/FloatingPaths"
import { InstitutionFormPanel } from "./InstitutionFormPanel"
import { TiltCard } from "../../components/ui/be-ui-tilt-card"

const InstitutionsSignup = () => {

  return (
    <>
      <Helmet>
        <title>Register Your Institution - Nesolearn</title>
        <meta
          name="description"
          content="Register your university, training institute, or organization on Nesolearn to deliver, track, and certify educational programs."
        />
      </Helmet>

      <main className="relative lg:grid lg:grid-cols-2 lg:h-screen">
        {/* Left panel — hidden on mobile */}
        <div className="relative hidden h-full flex-col justify-between p-10 lg:flex overflow-hidden" style={{ backgroundColor: "#1b1b1b" }}>
          <div className="flex items-center gap-3 z-10">
            <Link to="/home-landing-page">
              <img
                src="https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/NESOL_2D_Logo_-_Black_and_White-removebg-preview.png"
                alt="Nesolearn Logo"
                className="w-10 h-10 object-contain brightness-0 invert"
              />
            </Link>
            <Link
              to="/home-landing-page"
              aria-label="Go to home page"
              className="flex items-center justify-center w-9 h-9 rounded-md bg-white/10 text-white hover:bg-white/20 transition-smooth"
            >
              <Icon name="Home" size={16} />
            </Link>
          </div>

          <div className="z-10 mt-auto">
            <TiltCard className="w-full border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
              <blockquote className="space-y-2">
                <p className="text-xl text-white">
                  &ldquo;Nesolearn helped us deliver, track, and certify our first
                  cohort without building any of the infrastructure ourselves.&rdquo;
                </p>
                <footer className="font-mono font-semibold text-sm text-white/60">
                  ~ Pilot Partner, Blockchain Compliance Certification
                </footer>
              </blockquote>
            </TiltCard>
          </div>

          <div className="absolute inset-0">
            <FloatingPaths position={1} />
            <FloatingPaths position={-1} />
          </div>
        </div>

        {/* Right panel — the form */}
        <InstitutionFormPanel />
      </main>
    </>
  )
}

export default InstitutionsSignup